<template>
  <div class="tooltip">
    <table cellspacing="0" cellpadding="6">
      <thead>
        <tr>
          <th style="text-align: left;">指标名称</th>
          <th>来源系统</th>
          <th>更新频率</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>配送及时率</td>
          <td>报表平台</td>
          <td>2小时</td>
        </tr>
        <tr>
          <td>2b回单上传及时率</td>
          <td>报表平台</td>
          <td>2小时</td>
        </tr>
        <tr>
          <td>2c回单上传及时率</td>
          <td>报表平台</td>
          <td>10分钟</td>
        </tr>
        <tr>
          <td>遗失率</td>
          <td>数据银行</td>
          <td>T-1</td>
        </tr>
        <tr>
          <td>破损率</td>
          <td>数据银行</td>
          <td>T-1</td>
        </tr>
        <tr>
          <td>到车及时率</td>
          <td>数据银行</td>
          <td>T-1</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
    data () {
        return {

        };
    },
    method: {

    }
};
</script>

<style lang='less' scoped>
.tooltip {
  font-size: .7292vw;
  table tr th,
  table tr td {
    padding-right: 40px;
  }
  table tr th:last-child,
  table tr td:last-child {
    padding-right: 0;
  }
}
</style>